import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const ActivityCard = ({ activity }) => {
  const { t, lang } = useLang();

  return (
    <Link
      to={`/activites/${activity.slug}`}
      className="group relative flex flex-col bg-white rounded-2xl overflow-hidden border border-[#eceae1] transition-all duration-500 hover:shadow-[0_22px_50px_-18px_rgba(28,34,30,0.28)] hover:-translate-y-1"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={activity.image}
          alt={activity.title[lang]}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1c221e]/45 via-transparent to-transparent opacity-70" />

        {activity.popular && (
          <span className="absolute top-4 left-4 bg-[#f7f5ef]/95 text-[#5c6b54] text-[10px] font-semibold tracking-[0.18em] uppercase px-3 py-1.5 rounded-full backdrop-blur-sm">
            {t.activities.popular}
          </span>
        )}

        <span className="absolute top-4 right-4 flex items-center gap-1.5 bg-[#1c221e]/55 text-white text-[11px] tracking-wide px-3 py-1.5 rounded-full backdrop-blur-sm">
          <Clock size={12} /> {activity.duration[lang]}
        </span>
      </div>

      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-1.5 text-[11px] tracking-[0.12em] uppercase text-[#9aa08f] mb-2">
          <MapPin size={12} /> {activity.location[lang]}
        </div>
        <h3 className="font-serif text-[22px] leading-tight text-[#20261f] mb-2 group-hover:text-[#5c6b54] transition-colors">
          {activity.title[lang]}
        </h3>
        <p className="text-sm text-[#6b7166] leading-relaxed mb-5 line-clamp-2">
          {activity.short[lang]}
        </p>

        <div className="mt-auto flex items-end justify-between pt-4 border-t border-[#f0eee5]">
          <div>
            <p className="text-[11px] tracking-[0.1em] uppercase text-[#9aa08f]">{t.activities.from}</p>
            <p className="font-serif text-2xl text-[#20261f] leading-none mt-1">
              {activity.priceFromDhs} <span className="text-sm font-sans text-[#6b7166]">DHS</span>
            </p>
            <p className="text-xs text-[#9aa08f] mt-0.5">≈ {activity.priceFromEur} €</p>
          </div>
          <span className="flex items-center gap-1 text-[12px] tracking-[0.1em] uppercase font-medium text-[#5c6b54] group-hover:gap-2 transition-all">
            {t.activities.details}
            <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ActivityCard;
